import type { IPathBaseParam } from "./path";

import type { IApiResponse } from "@/api";
import { createGetApi } from "@api/util/createGetApi";
import type { IUserStatsResponse } from "@api/users/stats/types";

const getApis = createGetApi<
  IApiResponse<IUserStatsResponse>,
  IPathBaseParam,
  object
>("users.stats");

export const stats = {
  ...getApis,
};
